import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { format as formatDate } from 'date-fns';

import { FinalityLog } from '../../../domain/repositories/FinalityRepository';

const Container = styled.div`
  width: 450px;
`;

const EntryContainer = styled.div`
  margin-bottom: 25px;
  
  & > label {
    display: block;
    font-size: 1.4rem;
    font-weight: bold;
    margin-bottom: 5px;
  }

  & > p {

  }
`;

interface Props {
  finalityLogDetails?: FinalityLog;
}

export default function DetailsModalContent(props: Props) {
  const { finalityLogDetails } = props;

  if (!finalityLogDetails) return null;

  const {
    bankDetails,
    transactionDate,
    requestTime,
    client,
    responseCode,
    officeServer,
    responseDescription,
    responseBody
  } = finalityLogDetails;

  const transactionDateObject = new Date(transactionDate);
  const transactionDateString = formatDate(transactionDateObject, 'dd-MM-yyyy');
  const transactionTimeString = formatDate(transactionDateObject, 'hh:mm aa');

  const requestTimeDateObject = new Date(requestTime);
  const requestDateString = formatDate(requestTimeDateObject, 'dd-MM-yyyy');
  const requestTimeString = formatDate(requestTimeDateObject, 'hh:mm aa');

  return (
    <Container>
      <EntryContainer>
        <label>Bank Details</label>
        <p>{bankDetails}</p>
      </EntryContainer>


      <EntryContainer>
        <label>Transaction Date</label>
        <div>
          <p>{transactionDateString}</p>
          <p>{transactionTimeString}</p>
        </div>
      </EntryContainer>

      <EntryContainer>
        <label>Request Date</label>
        <div>
          <p>{requestDateString}</p>
          <p>{requestTimeString}</p>
        </div>
      </EntryContainer>

      <EntryContainer>
        <label>Requested By</label>
        <p>{client}</p>
      </EntryContainer>

      <EntryContainer>
        <label>Response Code</label>
        <p>{responseCode}</p>
      </EntryContainer>

      <EntryContainer>
        <label>Office Server</label>
        <p>{officeServer || '-'}</p>
      </EntryContainer>

      <EntryContainer>
        <label>Response Description</label>
        <p>{responseDescription || '-'}</p>
      </EntryContainer>

      <EntryContainer>
        <label>Response Body</label>
        <p style={{ wordBreak: "break-word" }}>{responseBody || '-'}</p>
      </EntryContainer>
    </Container>
  );
}